import { Grid } from "@material-ui/core";
import Controls from "../controls/Controls";
import { Form, useForm } from "../customHelpers/useForm";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useEffect } from "react";
import News from "../../actions/News";
import { isAuth } from "../../actions/auth";
import { Alert } from "@material-ui/lab";

const initialFValues = {
  body: "",
  title: "",
  author: "",
  editing: false,
  image: null,
};

const QuillModules = {
  toolbar: [
    ["bold", "italic", "underline", "strike"], // toggled buttons
    ["blockquote", "code-block"],
    ["image", "video", "link"],
    [{ header: 1 }, { header: 2 }, { header: [1, 2, 3, 4, 5, 6, false] }], // custom button values
    [{ list: "ordered" }, { list: "bullet" }],
    [{ script: "sub" }, { script: "super" }], // superscript/subscript
    [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
    [{ direction: "rtl" }], // text direction
    [{ size: ["small", "large", "huge", false] }], // custom dropdown
    [{ color: [] }, { background: [] }], // dropdown with defaults from theme
    [{ font: [] }],
    [{ align: [] }],
    ["clean"],
  ],
};
const QuillFormats = [
  "background",
  "bold",
  "color",
  "font",
  "code",
  "italic",
  "link",
  "size",
  "strike",
  "script",
  "underline",
  "blockquote",
  "header",
  "indent",
  "list",
  "align",
  "direction",
  "code-block",
  "formula",
  "image",
  "video",
];

const NewsForm = ({
  NotifyMessage,
  setOpenPopup,
  recordForEdit,
  getAllNews,
  isCompany = false,
  companyId = null,
}) => {
  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(recordForEdit || initialFValues, true, validate);

  useEffect(() => {
    if (recordForEdit !== null && recordForEdit !== undefined) {
      setValues({
        ...recordForEdit,
      });
    }
  }, [recordForEdit, setValues]);

  const { addNews, updateNews, userAddNews, updateCompanyNews } = News();

  function validate(fieldValues = values) {
    const temp = { ...errors };
    if ("body" in fieldValues)
      temp.body =
        fieldValues.body.length !== 0 && fieldValues.body !== "<p><br></p>"
          ? ""
          : "The body of the news can not be empty.";
    if ("title" in fieldValues)
      temp.title =
        fieldValues.title.length !== 0 ? "" : "This field is required.";
    if ("author" in fieldValues)
      temp.author =
        fieldValues.author.length !== 0 ? "" : "This field is required.";

    setErrors({
      ...temp,
    });
    if (fieldValues === values) return Object.values(temp).every((x) => x === "");
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      setValues({ ...values, submitting: true });

      const formData = new FormData();
      formData.append("title", values.title);
      formData.append("body", values.body);
      formData.append("author", values.author);
      if (values.image) {
        formData.append("image", values.image);
      }

      if (isCompany) {
        const user = isAuth();
        if (user?.email) formData.append("companyEmail", user.email || "");
        if (user?.name) formData.append("companyName", user.name || "");
        if (user?.description) formData.append("companyDescription", user.description || "");
        if (user?.logo) formData.append("companyLogo", user.logo || "");
      }

      const action = values.editing
        ? (isCompany ? updateCompanyNews(formData, values.Id) : updateNews(formData, values.Id))
        : (isCompany ? userAddNews(formData, companyId || "self") : addNews(formData));

      action.then((data) => {
        if (data.err) {
          setValues({ ...values, submitting: false });
          NotifyMessage({
            message: data.err,
            type: "error",
          });
        } else {
          NotifyMessage({
            message: data.message,
            type: "success",
          });
          setOpenPopup(false);
          resetForm();
          getAllNews();
        }
      });
    }
  };
  const handleBody = (name, value) => ({
    target: {
      name,
      value,
    },
  });

  return (
    <Form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Controls.Input
            name="title"
            label="Title"
            value={values.title}
            onChange={handleInputChange}
            error={errors.title}
          />
        </Grid>
        <Grid item xs={6}>
          <Controls.Input
            name="author"
            label="Author"
            value={values.author}
            onChange={handleInputChange}
            error={errors.author}
          />
        </Grid>


        <Grid item xs={12}>
          {" "}
          <ReactQuill
            modules={QuillModules}
            formats={QuillFormats}
            value={values.body}
            placeholder="what's on your mind"
            onChange={(e) => handleInputChange(handleBody("body", e))}
            theme="snow"
          />{" "}
          {errors.body && <Alert severity="error">{errors.body}</Alert>}
        </Grid>
        <Grid item xs={12}>
          <Controls.Button
            disabled={values.submitting ? true : false}
            text={
              values.editing === true
                ? values.submitting
                  ? "Editing..."
                  : "Edit"
                : values.submitting
                  ? "Publishing..."
                  : "Publish"
            }
            variant="contained"
            className="Button"
            type="submit"
          />
        </Grid>
      </Grid>
    </Form>
  );
};

export default NewsForm;
